import React from "react";

const ImageTag = ({ ...all }) => <img {...all} />;
export default ImageTag;
